<template>
  <div
    id="editor"
    class="col-sm-12 nopads"
  >
    <base-modal
      v-if="!assignmentMode"
      hide-footer
      size="lg"
      :title="defectUpdate.id > 0 ? $t('defects.edit') : $t('defects.new')"
      @close="$emit('close')"
    >
      <div class="col-sm-12 form-data nopads">
          <span class="item-detail-title">{{ defectUpdate?.contract?.name }}</span>
          <span class="span-title">{{ $t('vehicle_defects.inspectable') }}</span>
          <input
              v-model="defectUpdate.inspectable_name"
              type="text"
              class="form-control form-control-sm mb-2"
          />

          <span class="span-title">{{ $t('defects.description') }}</span>
          <textarea
              id="info"
              v-model="defectUpdate.description"
              class="form-control mb-2"
              rows="3"
          />

        <span class="span-title">{{ $t('defects.status') }}</span>
        <select
              id="status"
              v-model="defectUpdate.status"
              class="form-select form-select-sm sm-3"
        >
              <option :value="2">
                  {{ $t('inspection.options.okay') }}
              </option>
              <option :value="resultDefect">
                  {{ $t('inspection.options.defects') }}
              </option>
              <option :value="resultBan">
                  {{ $t('inspection.options.ban') }}
              </option>
        </select>

        <work-assignment-view
          :id="defect.id"
          :type="WORK_DEFECT"
          :can-edit="true"
          :can-add="isObserver"
          @edit-assignment="editAssignment"
        />

        <div class="col-sm-12 text-end mt-2">
          <button
            class="btn btn-secondary form-button"
            @click.stop="$emit('close')"
          >
            {{ $t('common.close') }}
          </button>
          <button
            class="btn btn-success form-button"
            :disabled="loading || !validateFields()"
            @click.stop="submit"
          >
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </base-modal>
    <div v-if="assignmentMode">
      <Transition name="fade">
        <work-assignment-editor
          :work-defect="defect"
          :is-observer="isObserver"
          :work-assignment="workAssignment"
          @close="setAssignmentEditorVisibility(false)"
          @close-and-update="closeAndUpdate"
        />
      </Transition>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {inspectionHelper} from '../../mixins/InspectionMixin'
import WorkAssignmentEditor from '../../workassignment/WorkAssignmentEditor'
import {workAssignmentHelper} from '../../mixins/WorkAssignmentMixin'
import WorkAssignmentView from '../../workassignment/WorkAssignmentView'
import BaseModal from "@/components/BaseModal.vue";
import {inject} from "vue";
import OpenContractFilter from "@/components/contract/OpenContractFilter";

export default {
    name: 'WorkDefectEditor',
    components: {OpenContractFilter, BaseModal, WorkAssignmentEditor, WorkAssignmentView},
    mixins: [restApi, inspectionHelper, workAssignmentHelper],
    props: {
        defect: {
            type: Object,
            default: null
        },
        isObserver: Boolean
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            defectUpdate: this.defect,
            workAssignment: null,
            assignmentMode: false
        }
    },
    methods: {

        checkValues: function (defect) {
            if (defect.status < 1 ||
                !defect.contract || defect.contract.id < 1 ||
                !defect.inspectable_name || defect.inspectable_name === '' ||
                !defect.description || defect.description === '') {
                return undefined
            }
            return defect
        },

        submit: function () {
            var json = this.checkValues(this.defectUpdate)
            if (json !== undefined) {
                this.loading = true
                this.restUpdate(this.workDefectUrl, json, this.success, this.fail)
            } else {
                this.showAlert(this.$t('defects.missing_fields'))
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        validateFields: function () {
            return this.defectUpdate.contract && this.defectUpdate.contract.id &&
                this.defectUpdate.inspectable_name.length > 0 && this.defectUpdate.status !== -1
        },

        setAssignmentEditorVisibility: function (visible) {
            this.assignmentMode = visible
        },

        closeAndUpdate: function (assignment) {
            this.setAssignmentEditorVisibility(false)
            this.workAssignment = assignment
        },
        editAssignment: function (assignment) {
            this.workAssignment = assignment
            this.setAssignmentEditorVisibility(true)
        }
    }

}
</script>

<style scoped>

</style>
